document.addEventListener('DOMContentLoaded', function () {
  const showcases = document.querySelectorAll('.product-showcase .product-showcase__products-wrapper');
  let flktyInstances = [];

  function initShowcaseSlider() {
    if (!showcases.length) return;

    if (window.innerWidth <= 820) {
      showcases.forEach((showcase, index) => {
        if (!flktyInstances[index]) {
          flktyInstances[index] = new Flickity(showcase, {
            cellAlign: 'left',
            contain: true,
            wrapAround: false,
            prevNextButtons: false,
            pageDots: true,
            draggable: true,
            cellSelector: '.product-showcase__column-product'
          });
        }
      });
    } else {
      flktyInstances.forEach((instance, index) => {
        if (instance) {
          instance.destroy();
          flktyInstances[index] = null;
        }
      });
    }
  }

  initShowcaseSlider();
  window.addEventListener('resize', initShowcaseSlider);
});